<div class="wrap" id="club">
  <!-- <google-map height="250px" width="100%" [center]="center">
    <map-marker [position]="marker?.position" [cdkDragDisabled]="false">
    </map-marker>
  </google-map> -->

  <div class="content">
    <!-- <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="15" [fullscreenControl]="true"
        (mapClick)="markerDragEnd($event)">
  
        <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
          (dragEnd)="markerDragEnd($event)">
        </agm-marker>
      </agm-map> -->

    <div class="loading" *ngIf="loading">
      <div>
        <mat-spinner [color]="color" [diameter]="100"></mat-spinner>
      </div>
    </div>
    <!-- <ngx-simplebar> -->
    <div class="background_search_bar">
      <div class="search_bar">
        <form [formGroup]="searchForm">
          <input ngx-google-places-autocomplete [options]='options' (onAddressChange)="addressChange($event)"
            formControlName="keyword" />
          <fa-icon [icon]=" faTimes" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
        </form>
        <fa-icon [icon]=" faSearch"></fa-icon>
      </div>
    </div>
    <span #target></span>

    <div class="flux_clubs" *ngFor="let c of clubs; let i = index">
      <app-list-clubs [club]="c" [index]="i">
      </app-list-clubs>
    </div>

    <p *ngIf="!clubs?.length" class="info_club_empty">Recherchez une ville ou activez votre géolocalisation.</p>
    <!-- </ngx-simplebar> -->
  </div>
</div>